import React from "react";
import { VendorAssessmentTabsUnit } from "./vendor-assessment-tabs-unit";

export function VendorAssessmentPage(): JSX.Element {
  return <VendorAssessmentTabsUnit />;
}
